<template>
    <div :ref="stepName" style="position:relative">
        <div v-if="step_mounted_status" class="progress-bar">
            <div class="normal fill">

            </div>
        </div>
        <div class="form-header">
            <p>Bevestiging via sms</p>
            <p><span>Je hebt een SMS ontvangen op de GSM die u ons hebt opgegeven:{{ phone }}</span></p>
            <p>Klik op de link in de SMS om verder te gaan met uw registratie.</p>
            <p v-if="isAffiliate"><span>Heb je nog geen SMS ontvangen? </span></p>
        </div>
        <SmsThanksForm></SmsThanksForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import SmsThanksForm from "./SmsThanksForm";
import {get} from "vuex-pathify";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { SmsThanksForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
    computed:{
        query_string: get('func_data/query_string'),
        isAffiliate(){
            return _.get(this.query_string, 'utm_medium') == 'affiliates';
        },
        phone: get('func_data/phone'),
        step_mounted_status: get('func_data/step_mounted_status'),
    }
}
</script>
